export enum EnterExitHistoryStatusColor {
	in = '#24D321',
	out = '#ED4141'
}

export enum EnterExitHistoryStatusText {
	in = 'Вход',
	out = 'Выход'
}
